<template>
  <FixedModalSmall>
    <div class="modal-content">
      <div class="p-2 d-flex justify-content-end">
        <button
          type="button"
          class="btn bg-soft-secondary btn-xs p-1"
          @click.prevent="$emit('cancel')"
        >
          <b-icon-x-lg class="fs-3"></b-icon-x-lg>
        </button>
      </div>
      <!-- Page Header -->
      <div class="modal-header border-bottom px-0 pt-0 pb-2">
        <h1 class="modal-title">Create Address</h1>
      </div>

      <div class="modal-body p-0 mt-5">
        <!-- line 1 -->
        <div class="row">
          <div class="col text-start">
            <div class="mb-4">
              <label class="form-label fw-bold" for="addressLine1"
                >Address line 1 (Street address, P.O. box)</label
              >
              <!-- <span
                v-if="!getAddressLine1"
                class="badge bg-soft-info rounded-pill ms-2"
                ><span class="text-danger">required</span>
              </span> -->
              <input
                type="url"
                class="form-control form-control-lg"
                :class="{ 'border-success': getAddressLine1 }"
                name="addressLine1"
                id="addressLine1"
                required
                placeholder="Street address, P.O box"
                aria-label="Street address, P.O box"
                v-model="addressLine1"
              />
            </div>
          </div>
        </div>
        <!-- line 2 -->
        <div class="row">
          <div class="col text-start">
            <div class="mb-4">
              <label class="form-label fw-bold" for="addressLine2"
                >Address line 2 (Apartment, suite, unit, building, floor,
                etc.)</label
              >
              <input
                type="url"
                class="form-control form-control-lg"
                :class="{ 'border-success': getAddressLine2 }"
                name="addressLine2"
                id="addressLine2"
                required
                placeholder="Street address, P.O box"
                aria-label="Street address, P.O box"
                v-model="addressLine2"
              />
            </div>
          </div>
        </div>
        <!-- city/state -->
        <div class="row">
          <div class="col-lg-6 text-start">
            <div class="mb-4">
              <label class="form-label fw-bold" for="city">City</label>
              <span v-if="!getCity" class="badge bg-soft-info rounded-pill ms-2"
                ><span class="text-danger">required</span>
              </span>
              <input
                type="url"
                class="form-control form-control-lg"
                :class="{ 'border-success': getCity }"
                name="city"
                id="city"
                required
                placeholder="St. Louis"
                aria-label="St. Louis"
                v-model="address.city"
              />
            </div>
          </div>
          <div class="col-lg-6 text-start">
            <div class="mb-4">
              <label class="form-label fw-bold" for="state">State</label>
              <span
                v-if="!getState"
                class="badge bg-soft-info rounded-pill ms-2"
                ><span class="text-danger">required</span>
              </span>
              <input
                type="url"
                class="form-control form-control-lg"
                :class="{ 'border-success': getState }"
                name="state"
                id="state"
                required
                placeholder="Missouri"
                aria-label="Missouri"
                v-model="address.state"
              />
            </div>
          </div>
        </div>
        <!-- postal code/country -->
        <div class="row">
          <div class="col-lg-6 text-start">
            <div class="mb-4">
              <label class="form-label fw-bold" for="postalCode"
                >Postal Code</label
              >
              <!-- <span
                v-if="!getPostalCode"
                class="badge bg-soft-info rounded-pill ms-2"
                ><span class="text-danger">required</span>
              </span> -->
              <input
                type="url"
                class="form-control form-control-lg"
                :class="{ 'border-success': getPostalCode }"
                name="postalCode"
                id="postalCode"
                required
                placeholder="63139"
                aria-label="63139"
                v-model="address.postalCode"
              />
            </div>
          </div>
          <div class="col-lg-6 text-start">
            <div class="mb-4">
              <div class="tom-select-custom">
                <label class="form-label fw-bold" for="countrySelect"
                  >Country</label
                >
                <!-- <span
                  v-if="!getCountry"
                  class="badge bg-soft-info rounded-pill ms-2"
                  ><span class="text-danger">required</span>
                </span> -->
                <select
                  class="form-select text-dark"
                  :class="{ 'border-success': getCountry }"
                  required
                  v-model="address.country"
                  name="countrySelect"
                  id="countrySelect"
                >
                  <option
                    v-for="option in countryOptions"
                    :value="option.value"
                    :key="option.index"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-start px-0">
        <!-- submit button -->
        <div class="d-flex flex-column align-items-start w-100 my-2">
          <p class="text-danger" v-if="!checkIfFormIsComplete">
            Form is incomplete. Please fix invalid or missing information.
          </p>
          <div class="d-flex gap-2" v-if="!addressIsSaving && !isSuccessful">
            <button
              :disabled="!checkIfFormIsComplete"
              type="button"
              class="btn btn-primary"
              @click.prevent="createSingleVendorAddress()"
            >
              Save address
            </button>
            <button
              type="button"
              class="btn btn-soft-secondary"
              @click.prevent="$emit('cancel')"
            >
              Cancel
            </button>
          </div>
          <button
            class="btn btn-primary"
            type="button"
            disabled
            v-if="addressIsSaving"
          >
            <span
              class="spinner-grow spinner-grow-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Saving address...
          </button>
          <button
            class="btn btn-primary"
            type="button"
            disabled
            v-if="isSuccessful"
          >
            <span class="text-success"
              ><b-icon-check-circle-fill></b-icon-check-circle-fill>
            </span>
            Success!
          </button>
        </div>
      </div>
    </div>
  </FixedModalSmall>
</template>

<script>
import FixedModalSmall from "../../modals/templates/FixedModalSmall.vue";

export default {
  name: "CreateAddressModal",
  components: {
    FixedModalSmall,
  },
  data() {
    return {
      addressList: [],
      addressIsSaving: false,
      isSuccessful: false,
      debounceTimer: null,
      doesVendorExist: false,
      address: {
        city: "",
        state: "",
        postalCode: "",
        country: "",
      },
      addressLine1: "",
      addressLine2: "",
      countryOptions: [
        { text: "Select country", value: "" },
        { text: "United States", value: "US" },
        { text: "Afghanistan", value: "AF" },
        { text: "Åland Islands", value: "AX" },
        { text: "Albania", value: "AL" },
        { text: "Algeria", value: "DZ" },
        { text: "American Samoa", value: "AS" },
        { text: "Andorra", value: "AD" },
        { text: "Angola", value: "AO" },
        { text: "Anguilla", value: "AI" },
        { text: "Antarctica", value: "AQ" },
        { text: "Antigua and Barbuda", value: "AG" },
        { text: "Argentina", value: "AR" },
        { text: "Armenia", value: "AM" },
        { text: "Aruba", value: "AW" },
        { text: "Australia", value: "AU" },
        { text: "Austria", value: "AT" },
        { text: "Azerbaijan", value: "AZ" },
        { text: "Bahamas", value: "BS" },
        { text: "Bahrain", value: "BH" },
        { text: "Bangladesh", value: "BD" },
        { text: "Barbados", value: "BB" },
        { text: "Belarus", value: "BY" },
        { text: "Belgium", value: "BE" },
        { text: "Belize", value: "BZ" },
        { text: "Benin", value: "BJ" },
        { text: "Bermuda", value: "BM" },
        { text: "Bhutan", value: "BT" },
        { text: "Bolivia", value: "BO" },
        { text: "Bosnia and Herzegovina", value: "BA" },
        { text: "Botswana", value: "BW" },
        { text: "Bouvet Island", value: "BV" },
        { text: "Brazil", value: "BR" },
        { text: "British Indian Ocean Territory", value: "IO" },
        { text: "Brunei Darussalam", value: "BN" },
        { text: "Bulgaria", value: "BG" },
        { text: "Burkina Faso", value: "BF" },
        { text: "Burundi", value: "BI" },
        { text: "Cambodia", value: "KH" },
        { text: "Cameroon", value: "CM" },
        { text: "Canada", value: "CA" },
        { text: "Cape Verde", value: "CV" },
        { text: "Cayman Islands", value: "KY" },
        { text: "Central African Republic", value: "CF" },
        { text: "Chad", value: "TD" },
        { text: "Chile", value: "CL" },
        { text: "China", value: "CN" },
        { text: "Christmas Island", value: "CX" },
        { text: "Cocos (Keeling) Islands", value: "CC" },
        { text: "Colombia", value: "CO" },
        { text: "Comoros", value: "KM" },
        { text: "Congo", value: "CG" },
        { text: "Congo, The Democratic Republic of the", value: "CD" },
        { text: "Cook Islands", value: "CK" },
        { text: "Costa Rica", value: "CR" },
        { text: "Cote D'Ivoire", value: "CI" },
        { text: "Croatia", value: "HR" },
        { text: "Cuba", value: "CU" },
        { text: "Cyprus", value: "CY" },
        { text: "Czech Republic", value: "CZ" },
        { text: "Denmark", value: "DK" },
        { text: "Djibouti", value: "DJ" },
        { text: "Dominica", value: "DM" },
        { text: "Dominican Republic", value: "DO" },
        { text: "Ecuador", value: "EC" },
        { text: "Egypt", value: "EG" },
        { text: "El Salvador", value: "SV" },
        { text: "Equatorial Guinea", value: "GQ" },
        { text: "Eritrea", value: "ER" },
        { text: "Estonia", value: "EE" },
        { text: "Ethiopia", value: "ET" },
        { text: "Falkland Islands (Malvinas)", value: "FK" },
        { text: "Faroe Islands", value: "FO" },
        { text: "Fiji", value: "FJ" },
        { text: "Finland", value: "FI" },
        { text: "France", value: "FR" },
        { text: "French Guiana", value: "GF" },
        { text: "French Polynesia", value: "PF" },
        { text: "French Southern Territories", value: "TF" },
        { text: "Gabon", value: "GA" },
        { text: "Gambia", value: "GM" },
        { text: "Georgia", value: "GE" },
        { text: "Germany", value: "DE" },
        { text: "Ghana", value: "GH" },
        { text: "Gibraltar", value: "GI" },
        { text: "Greece", value: "GR" },
        { text: "Greenland", value: "GL" },
        { text: "Grenada", value: "GD" },
        { text: "Guadeloupe", value: "GP" },
        { text: "Guam", value: "GU" },
        { text: "Guatemala", value: "GT" },
        { text: "Guernsey", value: "GG" },
        { text: "Guinea", value: "GN" },
        { text: "Guinea-Bissau", value: "GW" },
        { text: "Guyana", value: "GY" },
        { text: "Haiti", value: "HT" },
        { text: "Heard Island and Mcdonald Islands", value: "HM" },
        { text: "Holy See (Vatican City State)", value: "VA" },
        { text: "Honduras", value: "HN" },
        { text: "Hong Kong", value: "HK" },
        { text: "Hungary", value: "HU" },
        { text: "Iceland", value: "IS" },
        { text: "India", value: "IN" },
        { text: "Indonesia", value: "ID" },
        { text: "Iran, Islamic Republic Of", value: "IR" },
        { text: "Iraq", value: "IQ" },
        { text: "Ireland", value: "IE" },
        { text: "Isle of Man", value: "IM" },
        { text: "Israel", value: "IL" },
        { text: "Italy", value: "IT" },
        { text: "Jamaica", value: "JM" },
        { text: "Japan", value: "JP" },
        { text: "Jersey", value: "JE" },
        { text: "Jordan", value: "JO" },
        { text: "Kazakhstan", value: "KZ" },
        { text: "Kenya", value: "KE" },
        { text: "Kiribati", value: "KI" },
        { text: "Korea, Democratic People'S Republic of", value: "KP" },
        { text: "Korea, Republic of", value: "KR" },
        { text: "Kuwait", value: "KW" },
        { text: "Kyrgyzstan", value: "KG" },
        { text: "Lao People'S Democratic Republic", value: "LA" },
        { text: "Latvia", value: "LV" },
        { text: "Lebanon", value: "LB" },
        { text: "Lesotho", value: "LS" },
        { text: "Liberia", value: "LR" },
        { text: "Libyan Arab Jamahiriya", value: "LY" },
        { text: "Liechtenstein", value: "LI" },
        { text: "Lithuania", value: "LT" },
        { text: "Luxembourg", value: "LU" },
        { text: "Macao", value: "MO" },
        { text: "Macedonia, The Former Yugoslav Republic of", value: "MK" },
        { text: "Madagascar", value: "MG" },
        { text: "Malawi", value: "MW" },
        { text: "Malaysia", value: "MY" },
        { text: "Maldives", value: "MV" },
        { text: "Mali", value: "ML" },
        { text: "Malta", value: "MT" },
        { text: "Marshall Islands", value: "MH" },
        { text: "Martinique", value: "MQ" },
        { text: "Mauritania", value: "MR" },
        { text: "Mauritius", value: "MU" },
        { text: "Mayotte", value: "YT" },
        { text: "Mexico", value: "MX" },
        { text: "Micronesia, Federated States of", value: "FM" },
        { text: "Moldova, Republic of", value: "MD" },
        { text: "Monaco", value: "MC" },
        { text: "Mongolia", value: "MN" },
        { text: "Montserrat", value: "MS" },
        { text: "Morocco", value: "MA" },
        { text: "Mozambique", value: "MZ" },
        { text: "Myanmar", value: "MM" },
        { text: "Namibia", value: "NA" },
        { text: "Nauru", value: "NR" },
        { text: "Nepal", value: "NP" },
        { text: "Netherlands", value: "NL" },
        { text: "Netherlands Antilles", value: "AN" },
        { text: "New Caledonia", value: "NC" },
        { text: "New Zealand", value: "NZ" },
        { text: "Nicaragua", value: "NI" },
        { text: "Niger", value: "NE" },
        { text: "Nigeria", value: "NG" },
        { text: "Niue", value: "NU" },
        { text: "Norfolk Island", value: "NF" },
        { text: "Northern Mariana Islands", value: "MP" },
        { text: "Norway", value: "NO" },
        { text: "Oman", value: "OM" },
        { text: "Pakistan", value: "PK" },
        { text: "Palau", value: "PW" },
        { text: "Palestinian Territory, Occupied", value: "PS" },
        { text: "Panama", value: "PA" },
        { text: "Papua New Guinea", value: "PG" },
        { text: "Paraguay", value: "PY" },
        { text: "Peru", value: "PE" },
        { text: "Philippines", value: "PH" },
        { text: "Pitcairn", value: "PN" },
        { text: "Poland", value: "PL" },
        { text: "Portugal", value: "PT" },
        { text: "Puerto Rico", value: "PR" },
        { text: "Qatar", value: "QA" },
        { text: "Reunion", value: "RE" },
        { text: "Romania", value: "RO" },
        { text: "Russian Federation", value: "RU" },
        { text: "RWANDA", value: "RW" },
        { text: "Saint Helena", value: "SH" },
        { text: "Saint Kitts and Nevis", value: "KN" },
        { text: "Saint Lucia", value: "LC" },
        { text: "Saint Pierre and Miquelon", value: "PM" },
        { text: "Saint Vincent and the Grenadines", value: "VC" },
        { text: "Samoa", value: "WS" },
        { text: "San Marino", value: "SM" },
        { text: "Sao Tome and Principe", value: "ST" },
        { text: "Saudi Arabia", value: "SA" },
        { text: "Senegal", value: "SN" },
        { text: "Serbia and Montenegro", value: "CS" },
        { text: "Seychelles", value: "SC" },
        { text: "Sierra Leone", value: "SL" },
        { text: "Singapore", value: "SG" },
        { text: "Slovakia", value: "SK" },
        { text: "Slovenia", value: "SI" },
        { text: "Solomon Islands", value: "SB" },
        { text: "Somalia", value: "SO" },
        { text: "South Africa", value: "ZA" },
        { text: "South Georgia and the South Sandwich Islands", value: "GS" },
        { text: "Spain", value: "ES" },
        { text: "Sri Lanka", value: "LK" },
        { text: "Sudan", value: "SD" },
        { text: "Suriname", value: "SR" },
        { text: "Svalbard and Jan Mayen", value: "SJ" },
        { text: "Swaziland", value: "SZ" },
        { text: "Sweden", value: "SE" },
        { text: "Switzerland", value: "CH" },
        { text: "Syrian Arab Republic", value: "SY" },
        { text: "Taiwan, Province of China", value: "TW" },
        { text: "Tajikistan", value: "TJ" },
        { text: "Tanzania, United Republic of", value: "TZ" },
        { text: "Thailand", value: "TH" },
        { text: "Timor-Leste", value: "TL" },
        { text: "Togo", value: "TG" },
        { text: "Tokelau", value: "TK" },
        { text: "Tonga", value: "TO" },
        { text: "Trinidad and Tobago", value: "TT" },
        { text: "Tunisia", value: "TN" },
        { text: "Turkey", value: "TR" },
        { text: "Turkmenistan", value: "TM" },
        { text: "Turks and Caicos Islands", value: "TC" },
        { text: "Tuvalu", value: "TV" },
        { text: "Uganda", value: "UG" },
        { text: "Ukraine", value: "UA" },
        { text: "United Arab Emirates", value: "AE" },
        { text: "United Kingdom", value: "GB" },
        { text: "United States Minor Outlying Islands", value: "UM" },
        { text: "Uruguay", value: "UY" },
        { text: "Uzbekistan", value: "UZ" },
        { text: "Vanuatu", value: "VU" },
        { text: "Venezuela", value: "VE" },
        { text: "Viet Nam", value: "VN" },
        { text: "Virgin Islands, British", value: "VG" },
        { text: "Virgin Islands, U.S.", value: "VI" },
        { text: "Wallis and Futuna", value: "WF" },
        { text: "Western Sahara", value: "EH" },
        { text: "Yemen", value: "YE" },
        { text: "Zambia", value: "ZM" },
        { text: "Zimbabwe", value: "ZW" },
      ],
    };
  },
  computed: {
    checkIfFormIsComplete() {
      if (
        // !this.getAddressLine1 ||
        !this.getCity ||
        !this.getState
        // ||
        // !this.getPostalCode ||
        // !this.getCountry
      ) {
        return false;
      }
      return true;
    },
    getAddressLine1() {
      return this?.addressLine1;
    },
    getAddressLine2() {
      return this?.addressLine2;
    },
    getCity() {
      return this?.address?.city;
    },
    getState() {
      return this?.address?.state;
    },
    getPostalCode() {
      return this?.address?.postalCode;
    },
    getCountry() {
      return this?.address?.country;
    },
    vendorClass() {
      return {
        "is-invalid": !this.getVendorName,
        "is-valid": this.getVendorName,
      };
    },
  },
  methods: {
    async createSingleVendorAddress() {
      try {
        // Get the Bold client
        const api = await this.getBoldClient();

        // Prepare address lines
        const addressLines = [];
        if (this.addressLine1) {
          addressLines.push(this.addressLine1);
        }
        if (this.addressLine2) {
          addressLines.push(this.addressLine2);
        }

        // Create an address object
        let newAddress = {
          city: this.address.city,
          state: this.address.state,
          postalCode: this.address.postalCode,
          country: this.address.country,
        };

        // Conditionally add the 'lines' property
        if (addressLines.length > 0) {
          newAddress.lines = addressLines;
        }

        // Create the address using the API
        const response = await api.createAddresses(null, [newAddress]);

        // Handle a successful response
        this.isSuccessful = true;
        console.log("address created", response);

        const address = response.data.result.records[0];
        this.$emit("setNewAddress", address);
      } catch (error) {
        console.error("Error creating address", error);

        // Handle the error as needed
        console.log("address was NOT created");
      }
    },
  },
};
</script>

<style scoped>
#upload-region {
  width: 100%;
  background-color: #f8fafd;
  border: 0.125rem dashed rgba(231, 234, 243, 0.7);
  border-radius: 0.5rem;
  padding: 3rem 3rem;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  justify-content: center;
}

#upload-region.dragover {
  background-color: #f0f0f0;
}
</style>
